// Maps each catalogue category to one of the three Ox Resin product brands.
// Lives in a config file so we have a single source of truth between the
// brand landing tile, the brand drill-down page and any future filtering.

export const BRANDS = [
  { key: 'probound', label: 'ProBound',  blurb: 'Resin-bound stone systems',                color: '#2F5E96', ink: '#fff' },
  { key: 'proepoxy', label: 'ProEpoxy',  blurb: 'Epoxy & polyaspartic floor coatings',      color: '#7A0B7A', ink: '#fff' },
  { key: 'prodecor', label: 'ProDecor',  blurb: 'Decorative wall finishes & feature walls', color: '#D4A24B', ink: '#0B0B0E' },
  { key: 'oxresin',  label: 'Ox Resin',  blurb: 'Ceramic top coats — billed via the Ox Resin Xero org', color: '#1f4030', ink: '#fff' },
  { key: 'misc',     label: 'Miscellaneous', blurb: 'General consumables & uncategorised items', color: '#4B5563', ink: '#fff' },
];

export const CATEGORY_TO_BRAND = {
  // ProBound — driveways/resin-bound stone systems.
  'Resin Bound & Driveway Products': 'probound',

  // ProEpoxy — anything in the epoxy/polyaspartic floor system, incl. casting resins.
  'Casting Resins':                   'proepoxy',
  'Floor Preparation & Levelling':   'proepoxy',
  'Epoxy Primers (DPM Primer)':      'proepoxy',
  'Epoxy Design System':             'proepoxy',
  'Epoxy Shield Top Coats':          'proepoxy',
  'Polyaspartic & T2 Top Coats':     'proepoxy',
  'Metallic Pigments (100g)':        'proepoxy',
  'Glitters':                        'proepoxy',
  'High Build Coatings':             'proepoxy',
  'Solvents & Consumables':          'proepoxy',

  // ProDecor — decorative wall range.
  'Decorative Wall Primers':         'prodecor',
  'Decorative Wall Finishes':        'prodecor',
  'Decorative Wall Sealers':         'prodecor',
  'Decorative Wall Pigments':        'prodecor',
  'Decorative Waxes':                'prodecor',
  'Water-Based Decorative Finishes': 'prodecor',

  // Miscellaneous — standalone bucket for everything else.
  'Miscellaneous':                   'misc',
};

export function brandOfCategory(categoryName) {
  return CATEGORY_TO_BRAND[categoryName] || 'misc';
}

/**
 * Build a resolver that prefers the API-supplied `brand` on each category row
 * (set by the new "Add category" flow) and falls back to the static map for
 * legacy/seed categories. Use this on pages that have the categories list to
 * hand — keeps custom categories rendering under the right brand tile.
 *
 *   const resolveBrand = makeBrandResolver(categories);
 *   resolveBrand('My New Category')  // → 'probound' (from API) or 'misc' fallback
 */
export function makeBrandResolver(categories = []) {
  const map = Object.fromEntries(
    categories.filter(c => c.brand).map(c => [c.category, c.brand]),
  );
  return (categoryName) => map[categoryName] || CATEGORY_TO_BRAND[categoryName] || 'misc';
}
